
import { Button, ButtonBase, Checkbox } from '@mui/material';
import { React, useContext, useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';

import Modal from 'react-bootstrap/Modal';

import CheckIcon from '@mui/icons-material/Check';
import { SnackbarContext } from '../../App';
import { useAuth } from 'react-oidc-context';
import TransparentButtonDark from '../TransparentButtonDark';

export default ({ show, onClose, clientId, contactName, contactEmail, initialAutoForwarding, onRefresh }) => {
  const auth = useAuth();

  const { snackBarShow, setSnackBarShow, snackBarMessage, setSnackBarMessage, sessionExpired, setSessionExpired } = useContext(SnackbarContext);

  const [
    currentAutoForwarding,
    setCurrentAutoForwarding,
  ] = useState(initialAutoForwarding);

  useEffect(() => {
    setCurrentAutoForwarding(initialAutoForwarding);
  }, [show]);

  async function saveSelectedUsers() {
    console.log(contactEmail, contactName, contactEmail.length == 0, contactName.length == 0, currentAutoForwarding);
    if (((contactEmail && contactEmail.length == 0) || (contactName && contactName.length == 0)) && currentAutoForwarding) {
      setSnackBarMessage('Both contact name and contact email must be provided to enable auto-forwarding');
      setSnackBarShow(true);
      return;
    }

    try {
      const response = await fetch(`${window.origin}/api/client/${clientId}/auto-forwarding`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth.user?.access_token}`,
        },
        body: JSON.stringify({
          status: currentAutoForwarding,
        }),
      });

      if (response.status === 403) {
        setSessionExpired(true);
      } else if (!response.ok) {
        throw Error('Unexpected error occured');
      } else {
        onRefresh();
        setSnackBarMessage('Auto-forwarding updated');
        setSnackBarShow(true);
      }
      onClose();
    } catch (error) {
      setSnackBarMessage('Unexpected error occured. Please try again later');
      setSnackBarShow(true);
      onClose();
    }
  }

  return (
    <Modal style={{ paddingTop: '10vh', color: 'rgb(0, 0, 0, .8)' }} dialogClassName="modal-30w" show={show} onHide={onClose}>
      <Modal.Header style={{ border: 0, color: '#ee7170', padding: 0 }}>
      </Modal.Header>
      <Modal.Body style={{ padding: '1vw', paddingTop: '2vw', textAlign: 'center' }}>
        <p style={{ fontWeight: '500', fontSize: '1vw', marginBottom: '1vw' }}>Auto-forwarding</p>
        <div><p style={{ fontSize: '0.8vw', fontWeight: '400', marginBottom: '1vw', padding: '0vw 2vw' }}>Automatically forward report to client when there is a new report</p></div>

        <div style={{ margin: '2vw 0.5vw 0vw 0.5vw', backgroundColor: 'rgb(0, 0, 0, 0.04)', borderRadius: '1vw', overflow: 'hidden', maxHeight: '40vh', overflowY: 'scroll' }}>
          <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', padding: '1vw 1.2vw', borderRadius: '0', marginTop: '0', marginBottom: '0', width: '100%' }}>
            <div style={{ fontWeight: '500', fontSize: '0.8vw', marginRight: '2vw' }}>
              <p style={{ margin: 0, textAlign: 'left' }}>Auto-forwarding</p>
            </div>
            <div style={{ flex: 1, textAlign: 'right' }}>
              <div style={{ display: 'inline-block', backgroundColor: 'rgb(255, 255, 255, 0.8)', borderRadius: '0.6vw', padding: '0.2vw' }}>
                {[
                  'YES',
                  'NO',
                ].map((option, index) => (
                  <span style={{}}>
                    <TransparentButtonDark
                      style={{ padding: '0.1vw 0.5vw', borderRadius: '0.5vw' }}
                      onClick={() => {
                        setCurrentAutoForwarding(option == 'YES' ? true : false);
                      }}
                      selected={(currentAutoForwarding ? 'yes' : 'no') == option.toLowerCase()}
                    >
                      {option}
                    </TransparentButtonDark>
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer style={{ border: 0, alignItems: 'center', justifyContent: 'center', borderTop: '1px solid rgb(255, 255, 255, 0.1)', margin: '0.7vw' }}>

        <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
          <Button
            onClick={() => { onClose(false); }}
            variant="outlined"
            style={{ flex: 1,
              borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(0, 0, 0, 0.9)', padding: '0.5vw', border: 'none', backgroundColor: 'rgb(0, 0, 0, 0.07)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.08vw',
              width: '100%', marginRight: '0.5vw' }}
          >
            Close
          </Button>
          <Button
            onClick={saveSelectedUsers}
            variant="outlined"
            style={{ flex: 1,
              borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.5vw', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#1c6c6c, #1c6c6c)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.08vw',
              width: '100%' }}
          >
            Save
          </Button>

        </div>
      </Modal.Footer>
    </Modal>

  );
};
